import { QueryClient } from '@tanstack/react-query';

// React Query is the single home for server state (spec/12 §12.13).
// Cache TTLs (spec/12 §12.13): notifications 60 s, CSDB grid 30 s,
// user/project data 5 min. Per-query `staleTime` can override the default.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      gcTime: 10 * 60 * 1000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
    mutations: {
      retry: 0,
    },
  },
});
